import { QuoteFormSearchResponse } from '@lio/api-types';
import { quoteFormQueryKeys } from '@services/quoteForm/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchQuoteForms = (params: { quoteId?: string }) => {
  const client = useClient();
  const { quoteId } = params;

  const result = useQuery<QuoteFormSearchResponse, Error>({
    queryKey: [...quoteFormQueryKeys.searchWithParams({ quoteId: quoteId ?? '' })],
    queryFn: () => client.get(`quote/${quoteId}/quote-form`).json<QuoteFormSearchResponse>(),
    enabled: !!quoteId,
    staleTime: 20000,
  });
  return { ...result, quoteForms: result.data };
};
